import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { DropdownOptionModel } from '../../models/Common';

interface ILocationService {
  getCounties: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<DropdownOptionModel[]>>;
  getCities: (
    countyId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<DropdownOptionModel[]>>;
}

export const locationService: ILocationService = {
  getCounties(axiosConfig) {
    return ajax.get<DropdownOptionModel[]>(
      `${config.benefitApiUrl}/counties`,
      axiosConfig,
    );
  },
  getCities(countyId, axiosConfig) {
    return ajax.get<DropdownOptionModel[]>(
      `${config.benefitApiUrl}/counties/${countyId}/cities`,
      axiosConfig,
    );
  },
};
